export enum VariableStatusChangePopupReducerActionType {
  OpenVariableStatusChangePopup = 'variables/openVariableStatusChangePopup',
  CloseVariableStatusChangePopup = 'variables/closeVariableStatusChangePopup',
}
